import type { TourDefinition } from '../tourTypes';
import { hiringTour } from './hiring';
import { offerFormTour, offerTours } from './offers';

/** Every tour, in auto-start priority order. */
export const tours: TourDefinition[] = [hiringTour, offerFormTour, ...offerTours];

export const getTour = (id: string) => tours.find((tour) => tour.id === id);

export { OFFER_TOUR_IDS, type OfferTourRole } from './offers';
